import utils from '../utils/index';
/* type 分享类型枚举值 */
// type IShareType =
//   'text' |
//   'image' |
//   'miniApp' |
//   'dcommand'
export const EnumMiniProgramType = { Online: 0, Dev: 1, Review: 2 };
// 分享2.0：从init接口获取分享物料
export function getShareDataFromInit(_data) {
    // _data为init3返回的聚合数据
    const data = utils.cloneDeep(_data);
    const { conf = {}, xaks = {} } = data;
    const { xid, x_act_key, prod_key } = conf;
    let shareConf = {};
    // 主会场分享物料
    if (!conf.share_conf?.errCode) {
        shareConf[x_act_key] = {
            xid,
            prod_key,
            x_act_key,
            xak: x_act_key,
            ...conf.share_conf,
            isDefault: true,
        };
    }
    else {
        // 因为core包中不支持getOmega，需要在外侧调用时处理分享错误上报
        // getOmega((omega) => {
        //   omega.trackError('share_conf_error', conf.share_conf?.errMsg, {
        //     ...conf.share_conf
        //   })
        // })
        shareConf = conf.share_conf;
    }
    Object.keys(xaks).forEach(v => {
        // 活动模块分享数据注入(整合营销case)
        const { prod_key, x_act_key, xid } = xaks[v];
        if (xaks[v]?.share_conf && !xaks[v]?.share_conf?.errCode) {
            shareConf[x_act_key] = {
                ...xaks[v]?.share_conf,
                prod_key,
                xid,
                x_act_key,
                xak: x_act_key,
            };
        }
    });
    return shareConf;
}
// 分享2.0：获取当前页面或当前xak所需默认分享数据
export function getTargetShareConf({ shareConf = {}, xak = '', baseXposShare = {} }) {
    // 找到xak下的分享物料（原始数据）,默认当前主xak(主会场)
    // invokeShare不做兜底逻辑，找不到物料直接报错
    if (!(baseXposShare['idx']) && (baseXposShare['en'] || baseXposShare['rn'] || baseXposShare['xp'])) {
        // 合法性校验
        // idx 必须
        // pk cid可以自动读取
        // en rn xp 三选一
        console.error('参数缺失，请确保 idx 必须, en rn xp 三选一', baseXposShare);
        throw new Error('参数缺失，请确保 idx 必须, en rn xp 三选一');
    }
    // 因为core包中不支持storage，需要从外部传入shareConf
    const webxStorageShareConf = utils.cloneDeep(shareConf);
    const defaultConfig = Object.values(webxStorageShareConf).find(v => v.isDefault);
    // 未传入xak时使用默认物料兜底(主会场)
    let currentShareConf = webxStorageShareConf[xak] || defaultConfig; // 分享数据集查找，默认主会场兜底
    if (!currentShareConf) {
        // 合法性校验
        console.error('未找到匹配的分享数据集');
        throw new Error('未找到匹配的分享数据集');
    }
    console.log('当前分享 currentShareConf', currentShareConf);
    const { prod_key, xid } = currentShareConf;
    const xposShare = {
        ...baseXposShare, pk: prod_key, cid: xid
    };
    const currentShareMaterial = currentShareConf.share_data[xposShare['en'] || xposShare['rn'] || xposShare['xp']] || currentShareConf.share_data['default']; // 分享物料查找，为4个标准字段 + 额外数据
    const currentShareChannels = currentShareConf.share_channels; // 渠道查找，下发的是一个xak下的集合
    if (!currentShareMaterial) {
        // 合法性校验
        console.error('未找到匹配的分享物料');
        throw new Error('未找到匹配的分享物料');
    }
    if (!currentShareChannels) {
        console.error('未找到匹配的分享渠道');
        throw new Error('未找到匹配的分享渠道');
    }
    currentShareConf = {
        ...currentShareMaterial,
        share_channels: currentShareChannels,
        xposShare
    };
    return currentShareConf;
}
